// import PropTypes from 'prop-types';
// import { Storage } from 'aws-amplify';
// import { Grid, Box, ImageList, ImageListItem, IconButton } from '@mui/material';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Box, Card, CardMedia, CardActions, IconButton, Typography } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Storage } from 'aws-amplify';
import * as VenuesActions from '../../../../../core/venues/action';

function PicturesVenue({ images, onSelectImage, onDeleteImage, currentBannerKey }) {
  const [selected, setSelected] = useState(null);
  const [imageUrls, setImageUrls] = useState([]);

  useEffect(() => {
    async function fetchImageUrls() {
      if (images && images.length > 0) {
        const urls = await Promise.all(images.map((image) => Storage.get(image.key)));
        setImageUrls(urls);
      }
    }
    fetchImageUrls();
  }, [images]);

  // Initialize selected state based on current banner
  useEffect(() => {
    if (currentBannerKey && images && images.length > 0) {
      const bannerImage = images.find((img) => img.key === currentBannerKey);
      if (bannerImage) {
        setSelected(bannerImage.id);
      }
    }
  }, [currentBannerKey, images]);

  const handleSelect = (e, { id, key }) => {
    e.stopPropagation();
    setSelected(id);
    onSelectImage(key);
  };

  const handleDelete = (e, image) => {
    e.stopPropagation();
    onDeleteImage(image);
  };

  return (
    <Grid container spacing={2}>
      {imageUrls?.map((imageUrl, index) => {
        const image = images[index];
        const isSelected = selected === image?.id;
        return (
          <Grid item xs={12} sm={6} md={4} key={image?.id}>
            <Card
              sx={{
                display: 'flex',
                flexDirection: 'column',
                cursor: 'pointer',
                border: isSelected ? '2px solid #1976d2' : '1px solid #e0e0e0',
                '&:hover': {
                  boxShadow: 4,
                },
              }}
              onClick={(e) => handleSelect(e, image)}>
              <CardMedia component="img" height="250" image={imageUrl} alt="" />
              <CardActions
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '8px 16px',
                  backgroundColor: '#f5f5f5',
                }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {isSelected ? (
                    <>
                      <CheckBoxIcon sx={{ color: '#1976d2' }} />
                      <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                        Banner Image
                      </Typography>
                    </>
                  ) : (
                    <>
                      <CheckBoxOutlineBlankIcon sx={{ color: '#666' }} />
                      <Typography variant="body2" sx={{ color: '#666' }}>
                        Set as Banner
                      </Typography>
                    </>
                  )}
                </Box>
                <IconButton
                  sx={{ color: '#d32f2f' }}
                  onClick={(e) => handleDelete(e, image)}
                  aria-label="delete image">
                  <DeleteOutlineIcon />
                </IconButton>
              </CardActions>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
}

PicturesVenue.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      key: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onSelectImage: PropTypes.func.isRequired,
  onDeleteImage: PropTypes.func.isRequired,
  currentBannerKey: PropTypes.string,
};

PicturesVenue.defaultProps = {
  currentBannerKey: null,
};

export default PicturesVenue;
